'use es6';

import PropTypes from 'prop-types';
export default PropTypes.shape({
  filterBranchType: PropTypes.oneOf(['OR', 'AND', 'ASSOCIATION', 'RESTRICTED']).isRequired,
  filterBranchOperator: PropTypes.oneOf(['OR', 'AND', 'RESTRICTED']).isRequired,
  /* eslint-disable-next-line react/forbid-prop-types */
  filters: PropTypes.arrayOf(PropTypes.object).isRequired,
  /* eslint-disable-next-line react/forbid-prop-types */
  filterBranches: PropTypes.arrayOf(PropTypes.object).isRequired
});